// extracted by mini-css-extract-plugin
module.exports = {"heroBackground":"Hero_heroBackground__dgKs3"};